import "@hotwired/turbo-rails";
// import "./jquery";

import "./helpers/on";
import "./helpers/modal_picker";
import "./helpers/autosubmit";
import "./helpers/mark_viewed";
import "./helpers/focus_end";

$(document).on("turbo:load", function () {
	// INIT STUFF
	initDialog();
	initFlash();
	initTabbedSheet();
	initUploadInput();

	initFlickity();
});

// TODO: FIND A PLACE FOR THIS
Turbo.StreamActions.dialog_close = function () {
	this.targetElements.forEach((el) => el.close());
};
